// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
    "apiUrl": "https://trustzen.kryacheck.com/Vts2-Api/api/",
    "apiUrl1": "https://trustzen.kryacheck.com/trustzen-upd-api/api/",
    "pdfType": "1",
    "documentUrl": "https://trustzen.kryacheck.com/Vts2_Documents",
    "redirectUri": "https://trustzen.kryacheck.com/auth-callback",
    "acheck": 0,
    "candidate": 3,
    "ocrRoutes": {
    "EMPLOYMENT (HR)": "https://wfaprod.kryasolutions.com/webhook/employment",
    "EDUCATION": "https://wfaprod.kryasolutions.com/webhook/education",
    "ADDRESS": "https://wfaprod.kryasolutions.com/webhook/address",
    "VOTER ID": "https://wfaprod.kryasolutions.com/webhook/id",
    "PAN CARD": "https://wfaprod.kryasolutions.com/webhook/id",
    "PASSPORT": "https://wfaprod.kryasolutions.com/webhook/id",
    "NATIONAL IDENTITY CHECK": "https://wfaprod.kryasolutions.com/webhook/id",
    "LICENSE": "https://wfaprod.kryasolutions.com/webhook/id"
  },
  "BiometricFacialRecognitionUrl": "https://wfaprod.kryasolutions.com/webhook/biometriclivenesscheck",
  "googleMapsApiKey": "AIzaSyBI_KXoUsO_lG3y2YE1yqvP8U3-FJm-1SM",
  "digitalEmploymentVendorApiUrl": "https://biometric-trustzen.kryacheck.com/vendor-auto-screeningapi/",
  "purpose": "BackgroundVerification",
  "serviceName": "KryaScreening",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
